// extracted by mini-css-extract-plugin
export default {"root":"table-of-contents_root__h4SMn","toc":"table-of-contents_toc__P9cKl","refresh":"table-of-contents_refresh__DQFMB","refreshIcon":"table-of-contents_refreshIcon__D4lHx"};